var commonLinks = {
    INSTRUCTION: "INSTRUKCJA",
    SERVICE: "SERWIS",
    CONTACT: "KONTAKT",
};

var commonLabels = {
    Time_Of_Sending_To_OSP: "Czas wysłania do OSP",
    Open: "Otwórz",
    View: "Podgląd",
    Display: "Wyświetl",
    Edit: "Edycja",
    Delete: "Usuń",
    Cancel: "Anuluj",
    Add: "Dodaj",
    Confirm: "Potwierdź",
    MDM: "Miejsce Dostarczania Medium",
    MDMs: "Miejsca Dostarczania Medium",
    Id: "ID",
    Name: "Nazwa",
    Short_Name: "Nazwa skrócona",
    OSD: "OSD",
    OSD_Department: "Oddział OSD",
    Medium_Type: "Typ medium",
    No_Data: "&lt;brak_danych&gt;",
    Identification: "Identyfikacja",
    Delete_Object: "Czy chcesz usunąć ten obiekt?",
    Code: "Kod",
    Comment: "Komentarz",
    Error: "Błąd",
    Save: "Zapisz",
    Save_Changes: "Zapisz zmiany",
    Commit_Changes: "Zatwierdź",
    Add_New: "Dodaj",
    New_Window: "Nowe okno",
    Changelog: "Rejestr zmian",
    Select: "Wybierz",
    Type: "Typ",
    PPE_Code: "Kod PPE",
    CSPR_Code: "Kod CSPR",
    Object_Code: "Kod Obiektu",
    Users: "Użytkownicy",
    Data: "Dane",
    Sum: "Suma",
    Size: "Rozmiar",
    Save_Filter: "Zapisz filtr",
    Delete_Filter: "Usuń filtr",
    Filter_Name_Question: "Podaj nazwę filtra",
    Select_Filter: "Wybierz filtr",
    Date_From: "Data od",
    Date: "Data",
    Date_To: "Data do",
    Refresh: "Odśwież",
    Related_Documents: "Dokumenty powiązane",
    Operations: "Operacje",
    Download: "Pobierz",
    Close: "Zamknij",
    Hour: "Godzina",
    Minutes: "Minut",
    Consumption: "Zużycie",
    Status: "Status",
    Licence_Number: "Numer licencji",
    Time: "Czas",
    Lp: "Lp.",
    Winter_Time: "Zimowy",
    Summer_Time: "Letni",
    Version: "Wersja",
    Header: "Nagłówek",
    Answer: "Odpowiedź",
    Man_Position: "Stanowisko",
    Phone: "Telefon",
    Fax: "Fax",
    Count: "Ilość",
    Value: "Wartość",
    Reset_Grid_View: "Wyczyść ustawienia widoku",
    Document_Change_History: "Historia zmian na dokumencie",
    Changes_History: "Historia zmian",
    Conflicts: "Konflikty",
    Init: "Brak obiektu",
    Microinstallation: "Mikroinstalacja",
    Period_Method: "Metoda zatwierdzania rozliczeniowego",
    Data_Source: "Źródło danych",
    Contractor: "Kontrahent",
    Deleted: "Usunięty",
    Serial: "Numer seryjny",
    Client_ID: "ID klienta",
    Excise_ID: "ID akcyzy",
    Attachment_ID: "ID załącznika",
    References: "Odniesienia",
    AdditionalParameters: "Parametry dodatkowe",
    Day: "Dzień",
    Week: "Tydzień",
    Month: "Miesiąc",
    "Three months": "3 miesiące",
    "Half a year": "Pół roku",
    Year: "Rok",
    Information: "Informacja",
    Copy: "Kopiuj",
    Copy_From: "Kopiuj z",
    Copy_To: "Kopiuj do",
    New: "Nowy",
    Loading: "Ładowanie",
    CopyToClipboard: "Skopiuj do schowka",
    CopiedToClipboard: "Skopiowano do schowka",
    ExitQuestion: "Masz niezapisane zmiany. Czy na pewno chcesz wyjść?",
    Change_Secret_Value: "Zmień sekret w appsettings.json",
    Validate: "Waliduj",
    Clone: "Klonuj",
};

var pages = {
    Page_Not_Found: "Nie znaleziono strony",
    Access_Denied: "Nieuprawniony dostęp",
    Under_Construction: "Strona w budowie",
};

var signInPage = {
    Username: "Nazwa użytkownika",
    Password: "Hasło",
    Sign_In: "Zaloguj",
    Remember_Me: "Zapamiętaj mnie",
    Remind_Password: "Nie pamiętasz hasła?",
    Wrong_Password: "Zła nazwa użytkownika/hasło",
    User_Block: "Użytkownik zablokowany",
    User_Unblock: "Użytkownik odblokowany",
    Logging_In: "Logowanie do:",
    User_NoRole: "Użytkownik nie posiada roli dla tej aplikacji",
};

var dropdownUser = {
    Password_Change: "Zmień hasło",
    Profile: "Profil",
    Sign_Out: "Wyloguj",
};

var signOutScreen = {
    Logged_Out: "Wylogowano",
};

var httpErrors = {
    Error_400: "HTTP 400: Błędne żądanie",
    Error_401: "HTTP 401: Nieautoryzowany dostęp",
    Error_403: "HTTP 403: Zabroniony",
    Error_404: "HTTP 404: Nie znaleziono",
    Error_405: "HTTP 405: Niedozwolona metoda",
    Error_412: "HTTP 412: Warunek wstępny nie może być spełniony",
    Error_415: "HTTP 415: Nieobsługiwany błąd typu nośnika",
    Error_500: "HTTP 500: Wewnętrzny błąd serwera",
    Error_501: "HTTP 501: Niezaimplementowano",
};

var serviceScreen = {
    Service: "Serwis",
    API_Doc: "API adres",
    Ping: "Ping",
    DB_Connection_Status: "Status połączenia bazy danych",
    Connected: "Połączony",
    Disconnected: "Niepołączony",
    Log: "Log",
    Log_Settings: "Ustawienia logowania",
    Report_Problem: "Zgłoś problem",
    ServiceScreen: "Ekran Serwisu",
};

var address = {
    Street: "Ulica",
    ZipCode: "Kod pocztowy",
    City: "Miasto",
    Province: "Województwo",
    District: "Powiat",
    Commune: "Gmina",
    Block_Nr: "Numer domu",
    Apartment_Nr: "Numer mieszkania",
    Address: "Adres",
    Parcel: "Działka",
};

var changes = {
    FieldName: "Nazwa pola",
    PrevValue: "Poprzednia wartość",
    NextValue: "Następna wartość",
    Event: "Zdarzenie",
};

var user = {
    User: "Użytkownik",
    Users: "Użytkownicy",
    UserID: "ID użytkownika",
    Firstname: "Imię",
    Surname: "Nazwisko",
    Login: "Login",
    Yes: "Tak",
    No: "Nie",
    Blocked: "Zablokowany",
    Email: "Adres e-mail",
    Register_Date: "Data rejestracji",
    Last_Login_Date: "Data ostatniego logowania",
    Phone_Number: "Numer telefonu",
    Organization: "Organizacja",
    IsAdmin: "Administrator",
    Password_Used: "Hasło było już w użyciu",
    Changes_History: "Historia zmian",
};

var counter = {
    Counter: "Licznik",
    Tariff_Group: "Grupa taryfowa",
    OSD_Tariff_Group: "Grupa taryfowa OSD",
    Multiplicand: "Mnożna",
    Counterwidth: "Okienkowość",
    Meterdevice_ID: "ID rejestratora",
};

var account = {
    Password_Change: "Zmiana hasła",
    Old_Password: "Stare hasło",
    New_Password: "Nowe hasło",
    Confirm_Password: "Potwierdź hasło",
    Application: "Aplikacja",
    Applications: "Aplikacje",
    Role: "Rola",
    Domain_login: "Zaloguj się domenowo",
};

var userMessages = {
    Email_Taken: "Email jest już używany",
    DuplicateUserName: ["('\\S+')", "Nazwa użytkownika {0} jest już używana"],
    InvalidUserName: "Niepoprawna nazwa użytkownika",
    Email_Null: "Email jest wymagany",
    PasswordTooShort: ["(\\d+)", "Hasło musi się składać z co najmniej {0} znaków"],
    PasswordRequiresNonAlphanumeric: "Hasło musi zawierać co najmniej jeden znak specjalny",
    PasswordRequiresDigit: "Hasło wymaga co najmniej jednej cyfry",
    PasswordRequiresLower: "Hasło wymaga co najmniej jednej małej litery",
    PasswordRequiresUpper: "Hasło wymaga co najmniej jednej wielkiej litery",
    PasswordRequiresUniqueChars: ["(\\d+)", "Hasło musi zawierać co najmniej {0} różne znaki"],
    Password_Validator: "Hasło zostało zmienione",

    Name_Null: "Nazwa jest wymagana",
    Password_Null: "Hasło jest wymagane",
    ConfirmPassword_Null: "Potwierdzenie hasła jest wymagane",
    Passwords_Arent_Equal: "Hasła nie są zgodne",
    "Incorrect Password.": "Niepoprawne hasło.",
    Wrong_Password_Confirmation: "Nowe hasła nie są zgodne",
    Not_All_Password_Field: "Nie wszystkie pola haseł zostały wypełnione",
    "Controller::ClientDBErorr": "Błąd połączenia do bazy danych",
    "Controller::RemoveAddedRoles": "Błąd usuwania dodanej roli",
    "Controller::DeleteRoles": "Błąd usuwania roli",
    "Controller::AddRoles": "Błąd dodawania roli",
    "Controller::RoleNotFound": "Rola nie została znaleziona",
    "Controller::ApplicationNotFound": "Aplikacja nie została znaleziona",
    PasswordMismatch: "Niepoprawne hasło",
    InvalidEmailFormat: "Niepoprawny format maila",
    InvalidPhoneNumberFormat: "Niepoprawny format numeru telefonu",
    Password_Changed: "Hasło zostało zmienione",
};

var chart = {
    ChartTypeBar: "Słupkowy",
    ChartTypeLine: "Liniowy",
    ChartTypeStepArea: "Schodkowy warstwowy",
    ResetZoom: "Reset widoku",
    Measure_activeEnergy: "Energia czynna [kWh]",
    Measure_activePower: "Moc czynna [kW]",
    Measure_passiveEnergy: "Energia bierna [kVArh]",
    Measure_passivePower: "Moc bierna [KVAr]",
    Measure_volume: "Objętość [m^3]",
    Measure_flow: "Przepływ [m^3/h]",
    ChartData_Energy: "Energia",
    ChartData_Power: "Moc",
    Format: "Format",
};

var contact = {
    Contact: "Kontakt",
};

var buttons = {
    XML_View: "XML-Podgląd",
    Export_To_XLSX: "Eksport do XLSX",
    Send_XLSX: "Wyślij plik XLSX e-mailem",
    Delete_Document: "Usuń dokument",
    Make_Copies: "Stwórz kopię",
    Save_Draft: "Zapisz wersję roboczą",
    Save_And_Send: "Zapisz i wyślij",
};

var documentActionResult = {
    ok: "Akcja dla dokumentu o ID=%d zakończona sukcesem",
    forbidden: "Brak uprawnień do wykonania akcji dla dokumentu o ID=%d",
    forbidden_status: "Akcja niedozwolona z powodu statusu dokumentu dla dokumentu o ID=%d",
    error: "Błąd wykonania akcji dla dokumentu o ID=%d : %d",
};

var notifications = {
    Notifications: "Powiadomienia",
    Group: "Grupa",
    EmailNotifier: "Email",
    PushNotifier: "Push",
    RssNotifier: "Rss",
    AppNotifier: "W aplikacji",
    RSS_Subscription: "Subskrybuj RSS",
    MessageTemplate: "Szablon wiadomości",
    NotificationMessageTemplates: "Szablon wiadomości powiadomień",
    Title: "Tytuł",
    Text: "Treść",
    Lang: "Język",
    Group1: "Grupa główna",
    Group2: "Podgrupa",
};

var langs = {
    gb: "angielski",
    pl: "polski",
};

var localePL = {
    ...commonLinks,
    ...commonLabels,
    ...pages,
    ...signInPage,
    ...dropdownUser,
    ...signOutScreen,
    ...httpErrors,
    ...serviceScreen,
    ...address,
    ...changes,
    ...user,
    ...counter,
    ...account,
    ...userMessages,
    ...chart,
    ...contact,
    ...buttons,
    ...documentActionResult,
    ...notifications,
    ...langs,
};

export default localePL;
